// src/pages/News.js 
// (Assuming this file contains your News component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import NewsContent from './PageComponent/NewsContent'

function News() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>News | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Discover premium window treatments at Marvel Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort."
                />
                {/* Canonical URL is hardcoded as a string */}
                <link rel="canonical" href='https://marvellifestyle.com/news/' />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="News | Marvel Blinds" />
                <meta
                    property="og:description"
                    content="Discover premium window treatments at Marvel Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort."
                />
                <meta property="og:url" content='https://marvellifestyle.com/news/' />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <NewsContent />
                <Footer />
            </div>
        </>
    );
}

export default News;